<!-- <nb-card>
    <nb-card-header id="header-text" style="font-weight: bold;">{{header}}</nb-card-header>
      <nb-card-body style="text-align: center;">
          <label>{{message}}</label>
          <br><br>
        <div class="row show-grid">
          <div class="col">
            <button *ngIf="noButtonText" nbButton fullWidth (click)="close()" class="button-decor" style="text-align: center;">{{noButtonText}}</button>
          </div>
  
          <div class="col">
            <button *ngIf="yesButtonText" nbButton fullWidth (click)="continue()" style="text-align: center;">{{yesButtonText}}</button>
          </div>
  
        </div>
      </nb-card-body>
  </nb-card> -->

  <nb-card>
    <nb-card-header id="header-text" style="font-weight: bold;">{{header}}!</nb-card-header>
      <nb-card-body style="text-align: center;">
          <label>{{message}}</label>
          <br><br>
        <div class="row show-grid">
          <div class="col"></div>
  
          <div class="col">
            <button *ngIf="yesButtonText" nbButton fullWidth (click)="close()" style="text-align: center;">{{yesButtonText}}</button>
          </div>
  
        </div>
      </nb-card-body>
  </nb-card>
  